const ProjectName = 'KLN';
// const ipAddr = '52.197.196.72:53421';
// const ipAddr = '172.18.46.114:53421';
// const ipAddr = 'localhost:53421';
// const ipAddr = 'kml-dmms-uat.hk.kln.com/backend';
const ipAddr = 'kml-dmms.hk.kln.com/backend';

var getAPIURL = function () {
	sessionStorage.setItem('ipAddr', ipAddr)
	// return 'http://' + ipAddr;
	return 'https://' + ipAddr;
}

const CONFIG = {
	/**

	* [API_URL]

	* @description: 全站發 api 的 endpoint

	*/
	PROJECT_NAME: ProjectName,
	API_URL: getAPIURL(),
}

export { CONFIG };
